export default __webpack_public_path__ + "static/media/Animals-09.7751141e.png";